const logo = '/wp-content/uploads/2019/02/logo.png'
const token = 'TmAqifaxnwvG4B6mEMq0'

export {
    logo,
    token
}
